import React from "react";
import {Colors} from "../../ui";
import {IconAlertOutlined} from "../bounce-ui";
import {InputAdornment} from "@mui/material";

export const getValidatedTextFieldStyles = (invalid: boolean, noEndIcon?: boolean) => ({
  InputLabelProps: {
    shrink: true,
  },
  ...(invalid &&
    !noEndIcon && {
      InputProps: {
        endAdornment: (
          <InputAdornment position="end">
            <IconAlertOutlined color={Colors.red._900} />
          </InputAdornment>
        ),
      },
    }),
  FormHelperTextProps: {
    sx: {
      "&.Mui-error": {
        color: Colors.red._900,
      },
    },
  },
  sx: {
    marginBottom: invalid ? "22px" : "12px",
    "& .MuiInputBase-root": {
      alignItems: "center",
    },
  },
});
